import { FC } from "react"
import s from "@pages/fid_view/styles.module.css"
import { Typography } from "@mui/material"
import { cardTitle } from "@components/CardEvent/CardEvent/CardEventStyles"
import { YandexMapBox } from "@common/yandex/YandexMapBox"
import { selectCoordinate } from "@shared/selectors/address"
import { DetailedEventInSearchDto } from "@app/data/tribeSwaggerApi"
import LocationIconCard from "/src/assets/svg/card-icons-pack/location-icon.svg?react"

export interface LocationContentProps {
  eventInfo?: DetailedEventInSearchDto
}
const LocationContent: FC<LocationContentProps> = ({ eventInfo }) => {
  if (!eventInfo) return null
  if (
    eventInfo.is_private &&
    !eventInfo.event_address?.event_latitude &&
    !eventInfo.event_address?.event_longitude
  ) {
    return (
      <Typography gutterBottom variant="h6" component="div" sx={cardTitle}>
        Расположение скрыто настройками приватности
      </Typography>
    )
  }
  return (
    <div className={s.description_box}>
      <Typography gutterBottom variant="h6" component="div" sx={cardTitle}>
        Расположение:
      </Typography>
      <div className={s.map}>
        {eventInfo && eventInfo.event_address && (
          <YandexMapBox
            width={300}
            height={280}
            center={selectCoordinate(eventInfo.event_address)}
            isShowZoom={true}
            zoom={16}
          />
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          gap: "8px",
        }}
      >
        <LocationIconCard />
        <Typography variant="body2" color={`var(--secondary-text)`}>
          {`${eventInfo?.event_address?.city || ""}, ${
            eventInfo?.event_address?.street || ""
          } ${eventInfo?.event_address?.house_number || ""}`}
        </Typography>
      </div>
    </div>
  )
}
export default LocationContent
